import type { TModule } from '@modules/core/types';

import { AUTH_ROUTES } from './auth';
import { PUBLIC_ROUTE_PATHS } from './config';

/**
 * Represents the "Public" module.
 *
 * @remarks
 * This module encapsulates the routing and permissions configuration for `public` related features.
 * It includes authentication and other public-facing functionality that doesn't require user authentication.
 *
 * @property id - A unique identifier for the module ("public").
 * @property permissions - The access control configuration that restricts module access,
 *                         allowing only users with the appropriate roles or scopes.
 * @property routes - An array that lists the routes for the module.
 */

const publicModule: TModule = {
  id: 'public',
  fallbackRoute: [PUBLIC_ROUTE_PATHS.login],
  permissions: { roles: [] },
  isPublic: true, // Mark this entire module as public (no auth required)
  routes: [
    ...AUTH_ROUTES,
    // Additional auth routes
  ],
};

export { PUBLIC_ROUTE_PATHS as PublicRoutePaths };

export default publicModule;
